import { portalDs } from 'src/components/portal-design-system';
import { cn } from 'src/lib/utils';

export function GoogleCalendarNotConfiguredBanner() {
  return (
    <div className="rounded-xl border border-[#FDE68A] bg-[#FFFBEB] px-4 py-3">
      <p className="text-[14px] font-semibold text-[#92400E]">
        Google Calendar is not configured
      </p>
      <p className={cn(portalDs.caption, 'mt-1 text-[#B45309]')}>
        Portal needs GOOGLE_CALENDAR_CLIENT_ID, GOOGLE_CALENDAR_CLIENT_SECRET,
        GOOGLE_CALENDAR_TOKEN_ENCRYPTION_KEY, and GOOGLE_CALENDAR_REDIRECT_URI
        before teammates can connect calendars.
      </p>
    </div>
  );
}
